import React, { Component } from "react";
import { connect } from "react-redux";
import Typography from "material-ui/Typography";
import Profiles from "../data/Profiles.json";
import { Link } from "react-router-dom";
import Button from "material-ui/Button";
import getProfile from "../utils/getProfile";
class ProfileView extends Component {
  state = {};

  constructor(props) {
    super(props);
    this.state = {
      profile: getProfile(props.quiz.questions),
    };
  }

  textFormater(text_array) {
    return text_array.map((item) => {
      return (
        <ul key={item} className="articles-list">
          {item.map((subitem, i) =>
            subitem
              .split("<nb/>")
              .map((split_item, i) => <li key={i}> {split_item} </li>)
          )}
        </ul>
      );
    });
  }

  render() { 
    /* Storing profile text */
    let profiles = Profiles.profiles[this.state.profile];

    let sProfileText_text_title_1 = profiles.text_title_1;
    let sProfileText_text_title_2 = profiles.text_title_2;
    let sProfileText_text_2 = profiles.text_2; /* Ecological integrity */
    let sProfileText_text_3 = profiles.text_3; /* Social and economic justice */
    let sProfileText_text_4 = profiles.text_4; /*Democracy, nonviolence...*/

    return (
      <section>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <Typography
                component="div"
                className="profile-text-wrap"
              >
                <h3 className="profile-title-1">Earth Charter articles for</h3>
                <h3 className="profile-title-1">{sProfileText_text_title_1}</h3>
                <h4 className="profile-title-2">{sProfileText_text_title_2}</h4>

                {/* Ecological integrity */}
                <h4 className="profile-text-title">
                  Ecological integrity <br />
                  <span className="profile-subtitle">Principles</span>
                </h4>

                {this.textFormater(sProfileText_text_2)}

                {/* Social and economic justice */}
                <h4 className="profile-text-title">
                  Social and economic justice <br />
                  <span className="profile-subtitle">Principles</span>
                </h4>

                {this.textFormater(sProfileText_text_3)}

                {/* Democracy, nonviolence and peace */}
                <h4 className="profile-text-title">
                  Democracy, nonviolence and peace <br />
                  <span className="profile-subtitle">Principles</span>
                </h4>

                {this.textFormater(sProfileText_text_4)}
              </Typography>
              <Link to={"/goals"}>
                <Button
                  variant="raised"
                  style={{ marginBottom: "20px" }}
                  color="primary"
                >
                  Next
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps({ quiz }, { match: { params } }) {
  return {
    quiz,
  };
}
export default connect(mapStateToProps)(ProfileView);



// WEBPACK FOOTER //
// ./src/views/ArticlesView.jsx